import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advertisementbanner',
  templateUrl: './advertisementbanner.component.html',
  styleUrls: ['./advertisementbanner.component.css']
})
export class AdvertisementbannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
